import styled from "@emotion/styled";
import { colors } from "styles/colors";
import { fonts } from "styles/fonts";
import { InputWrap } from "shared/Input/styled";
import { IcoWrap, LabelStyled, InfoText, WrapperBtn, LabelButton } from "shared/InputPhoto/styled";
import { RadioButtonWrap } from "shared/RadioButton/styled";
import { TitleWrap, CategoryTitle } from "styles/AddRecipe.styled";
import { ButtonWrap } from "shared/Button/styled";

export const Title = styled.h1`
  padding: 0;
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 36px;
  line-height: 1.2;
  font-family: ${fonts.abhayaBold};
  @media (min-width: 450px) {
    margin-bottom: 13px;
  }
`;

export const Text = styled.div`
  ${(props) => props.fontBold && `font-family: ${fonts.latoBold}`};
`;
export const CardWrapper = styled.label`
  display: block;
  border: 1px solid ${colors.GREY_SEMILIGHT};
  border-radius: 5px;
  background: ${colors.WHITE};
  padding: 29px 22px 27px 19px;
  width: 100%;
`;

export const RestrictedMsg = styled.div`
  color: ${(props) => (props.isComplete === "Restricted" ? colors.RED_LIGHT : colors.GREY_DARK)};
`;

export const CardDelete = styled.div`
  width: 36px;
  height: 36px;
  border: 1px solid ${colors.RED_LIGHT};
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 2px;
  color: ${colors.RED_LIGHT};
  transition: border 0.4s, color 0.4s;

  &:hover {
    border: 1px solid ${colors.RED};
    color: ${colors.RED};
  }
`;
export const CardItem = styled.div`
  max-width: 405px;
  width: 100%;
`;
export const CardPayment = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  ${CardItem} {
    margin-bottom: 20px;
  }
  @media (min-width: 1024px) {
    flex-direction: row;
    ${CardItem}:nth-child(2n + 1) {
      margin-right: 20px;
    }
  }
`;

export const CardPayout = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CardPayoutDeskTop = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Actions = styled.div`
  margin-left: 15px;
  display: flex;
`;

export const Check = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 2px solid ${colors.GREY_SEMILIGHT};
  border-radius: 20px;
  margin-right: 10px;
  cursor: pointer;

  .icon {
    display: none;
    fill: ${colors.WHITE};
    stroke: ${colors.WHITE};
  }
`;

export const Delete = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid ${colors.GREY_SEMIDARK};
  color: ${colors.GREY_DARK};
  border-radius: 50%;
  cursor: pointer;

  .icon {
    width: 20px;
    height: 20px;
  }
`;

export const Label = styled.p`
  text-transform: uppercase;
  color: ${colors.GREY};
  font-weight: 500;
  font-size: 14px;
  margin: 14px 0 1px;
`;

export const LabelValue = styled.label`
  font-size: 14px;
  @media (min-width: 769px) {
    font-size: inherit;
  }
`;

export const Value = styled.p`
  font-family: ${fonts.latoBold};
  font-size: ${(props) => (props.fontsize ? "18px" : " 20px")};
  color: ${colors.GREY_DARK};
  margin: 0;
`;

export const Input = styled.input`
  position: absolute;
  left: -99999px;

  &:checked {
    & + label {
      border-color: ${colors.GREEN};

      ${Check} {
        border: none;
        background: ${colors.GREEN};

        .icon {
          display: block;
        }
      }
    }
  }
`;

export const LabelBig = styled.div`
  font-family: ${fonts.latoBold};
  font-size: 20px;
  letter-spacing: -0.2px;
  &.border {
    border-bottom: 1px solid ${colors.GREY_LIGHT};
    padding: 0 0 11px;
    margin-bottom: 16px;
  }
  @media (min-width: 769px) {
    letter-spacing: -0.3px;
    &.border {
      padding: 0 0 11px;
      margin-bottom: 19px;
    }
  }
`;

export const SettingWrapper = styled.div`
  max-width: 832px;
  padding-top: 40px;
`;

export const InfoWrap = styled.div`
  width: 100%;
  max-width: ${(props) => (props.width1 ? "374px" : " 563px;")};
  > ${InputWrap} {
    margin-top: 19px;
  }
`;

export const AddCard = styled.div`
  display: flex;
  justify-content: center;
  border: ${(props) => (props.isSettings ? `1px solid ${colors.GREY_SEMILIGHT}` : "none")};
  border-radius: 20px;
  padding: 26px 28px 28px;
  margin-bottom: 20px;

  @media (min-width: 769px) {
    ${(props) => props.isSettings && `width: 100%; max-width: 508px;`};
    margin-top: ${(props) => (props.isSettings ? `11px` : `0`)};
    padding: ${(props) => (props.isSettings ? `36px 0 38px` : `0`)};
    margin-bottom: 35px;
  }
`;

export const AddCardContent = styled.div`
  max-width: 428px;
  width: 100%;

  .input-mask {
    font-size: 16px;
    width: 100%;
    height: 46px;
    border: 2px solid ${(props) => (props.error ? colors.RED : colors.GREY_SEMILIGHT)};
    padding: 10px 12px;
    border-radius: 5px;
    outline: 0;
    box-shadow: none;
  }

  ${InputWrap} {
    margin-top: 14px;
    label {
      display: block;
    }
  }
  ${InputWrap} + div {
    margin-top: 14px;
  }
  .zip {
    ${InputWrap} {
      margin-top: 10px;
    }
  }
  @media (min-width: 769px) {
    .zip {
      ${InputWrap} {
        margin-top: 0;
      }
    }
    ${InputWrap} {
      margin-top: 18px;
    }
    ${InputWrap} + div {
      margin-top: 18px;
    }
  }
`;

export const InputWithIcon = styled.div`
  position: relative;

  .icon {
    stroke: ${colors.GREY};
    position: absolute;
    top: 15px;
    left: 10px;
    width: 24px;
    height: 18px;
  }

  input.input-mask {
    padding-left: 44px;
  }
`;

export const AddCardInputWrap = styled.div`
  input.input-mask {
    border-color: ${(props) => (props.error ? colors.RED : colors.GREY_SEMILIGHT)};
  }
`;

export const AddCardBtn = styled.div`
  margin-top: 16px;
  padding-top: 20px;
  border-top: 1px solid ${colors.GREY_LIGHT};
  button {
    width: 100%;
  }

  @media (min-width: 769px) {
    margin-top: 20px;
    padding-top: 20px;
  }
`;

export const BecomeCreatorText = styled.p`
  margin-bottom: 40px;
`;

export const BecomeCreatorBottom = styled.div`
  background-color: ${colors.GREY_LIGHT};
  padding: 15px;
  border-radius: 10px;
  form {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }
  button {
    width: 100%;
    margin: 10px 0 0;
  }
  @media (min-width: 769px) {
    border-radius: 20px;
    padding: 30px;
    button {
      width: auto;
      margin: 0 0 0 10px;
    }
  }
  ${InputWrap} {
    flex: 1;
    width: 100%;
  }
`;

export const TextValue = styled.p`
  &.text-center {
    text-align: center;

    @media (min-width: 769px) {
      text-align: left;
    }
  }

  &.value {
    margin-top: 0;
    @media (min-width: 769px) {
      margin-top: 10px;
    }
  }
`;

export const BigText = styled.div`
  font-size: 18px;
  margin: 0 10px 0 0;

  font-family: ${(props) => props.fontFamily && `${fonts.latoBold}`};
`;

export const CommentText = styled.div`
  font-family: ${fonts.latoRegular};
  color: ${colors.GREY_SEMIDARK};
  font-size: 16px;
`;

export const Balance = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  padding-left: 15px;
  button {
    min-width: 100%;
    @media (min-width: 769px) {
      min-width: 135px;
      padding-left: 0;
    }
  }
`;
export const BalanceButton = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  button {
    min-width: 100%;
  }
  @media (min-width: 769px) {
    width: auto;
    button {
      min-width: 135px;
    }
  }
`;

export const PayoutColumn = styled.div`
  padding: 0 8px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  @media (min-width: 769px) {
    ${(props) => (props.column === "type1" ? "flex: 1;" : "flex: 0 0 auto;")};
    width: auto;
  }
`;

export const PayoutRow = styled.div`
  display: flex;
  flex-direction: row;
`;

export const PayoutBalance = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 -8px;
  flex-direction: column;
  @media (min-width: 769px) {
    flex-direction: row;
  }
`;

export const PayoutItem = styled.div`
  margin-bottom: 19px;
  ${CategoryTitle} {
    margin-bottom: 18px;
  }
  ${PayoutColumn} + ${PayoutColumn} {
    margin-top: 17px;
  }
  @media (min-width: 769px) {
    margin-bottom: 40px;
    ${PayoutColumn} + ${PayoutColumn} {
      margin-left: auto;
      margin-top: 0;
    }
    ${CategoryTitle} {
      margin-bottom: 40px;
    }
  }
`;

export const MainTitle = styled.h3`
  font-weight: bold;
  font-size: 24px;
  margin: 0 0 20px;

  &.no-margin {
    margin-bottom: 0;
  }
`;

export const SaveBtn = styled.div`
  text-align: right;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid ${colors.GREY_LIGHT};
  @media (min-width: 769px) {
    margin-top: 30px;
    padding-top: 21px;
  }
  button {
    min-width: 100%;
    @media (min-width: 769px) {
      min-width: 112px;
    }
  }
`;

export const ImgIcon = styled.img`
  display: block;
  max-width: 58px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
`;
export const Dropzone = styled.div`
  width: 100%;
  min-height: 300px;
  padding-bottom: 30px;
  background-color: ${colors.GREY_LIGHT};
  border: 1px dashed ${colors.GREY_SEMILIGHT};
  text-align: center;
  cursor: pointer;
  border-radius: 10px;
  @media (min-width: 1024px) {
    width: 460px;
  }

  &.active {
    border: 1px dashed ${colors.RED};
    p,
    b,
    p:last-child {
      color: ${colors.RED};
    }
  }
  p {
    color: ${colors.GREY_SEMIDARK};

    &:last-child {
      color: ${colors.GREY};
    }

    b {
      color: ${colors.GREY_DARK};
    }
  }
`;

export const SelectDate = styled.div`
  display: flex;
  margin: 17px -5px 0;
  @media (min-width: 769px) {
    margin-top: 38px;
  }
`;
export const EditPayment = styled.div`
  ${TextValue} {
    margin-top: 0;
  }
`;

export const EditPaymentItem = styled.div`
  margin-top: 19px;
  width: 100%;
  ${(props) => props.itemType1 && "line-height: 1.45; max-width: 516px;"};
  ${(props) => props.itemType2 && "max-width: 402px;"};

  ${InputWrap} + ${InputWrap} {
    margin-top: 18px;
  }
  ${InputWrap} {
    label {
      display: block;
    }
  }

  ${BigText} +${Text} {
    margin-top: 8px;
  }
  @media (min-width: 769px) {
    margin-top: 40px;
  }
`;

export const InfoTitle = styled.div`
  font-family: ${fonts.latoBold};
  margin-bottom: 6px;
`;

export const InfoDescription = styled.div`
  color: ${colors.GREY_SEMIDARK};
`;

export const InfoContent = styled.div`
  flex-grow: 1;
  line-height: 1.4;
  @media (min-width: 769px) {
    margin-top: 34px;
    line-height: inherit;
  }
  p {
    margin-top: 0;
    margin-bottom: 20px;
    @media (min-width: 769px) {
      margin-bottom: 25px;
    }
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  height: 310px;
  width: 100%;
  border-radius: 10px;
  margin: 0 auto;
  cursor: pointer;
  background: ${colors.GREY_LIGHT};
  border: 1px dashed #dce0e0;
  ${WrapperBtn} {
    ${LabelButton} + ${LabelButton} {
      margin-top: 10px;
    }
  }

  ${IcoWrap} {
    text-align: center;
    > div + div {
      margin-top: 5px;
    }
  }

  @media (min-width: 769px) {
    ${(props) =>
      props.typeStyle === "upLoadSetting"
        ? `
        max-width: 460px;         
        margin: 0;
        ${InfoText}{
          color: ${colors.GREY};
        }`
        : `
        width: 186px; 
        height: 186px; 
        margin: 0 31px 0 0;
      `}

    ${IcoWrap} {
      margin-top: 0;
      margin-bottom: 0;

      .icon {
        width: 30px;
        height: 30px;
        margin-bottom: 0;
      }
    }
  }

  ${LabelStyled} {
    text-align: center;
    padding: 9px 20px;

    .icon {
      vertical-align: text-bottom;
      stroke: ${colors.WHITE};
      margin-left: 10px;

      @media (min-width: 769px) {
        display: none;
      }
    }
  }

  ${(props) =>
    props.photo
      ? `
          label{ 
          .icon{
            display: none;
          } 
      }      
      `
      : `
      label{
        .icon{
          display: inline-block;
        }
      } 
  `};
`;

export const InfoImage = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 20px;
  margin-bottom: 17px;
  border-bottom: 1px solid ${colors.GREEN_LIGHT};
  ${ImageWrapper} {
    margin-bottom: 20px;
  }
  @media (min-width: 769px) {
    padding: 0;
    margin: 0;
  }
`;
export const SripeWrapper = styled.div`
  width: 100%;
  height: 46px;
  border: 1px solid #dce0e0;
  padding: 13px 0.875em 11px;
  border-radius: 5px;
  outline: 0;
`;

export const LabelCountry = styled.div`
  color: ${(props) => (props.error ? "red" : colors.GREY_DARK)};
  font-size: 14px;
  margin-bottom: 2px;
`;

export const ButtonsInfo = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin: 18px -10px 0;
  border-top: 2px solid ${colors.GREY_LIGHT};
  button {
    width: 100%;
  }
`;

export const BtnItem = styled.div`
  padding: 10px;
  @media (min-width: 480px) {
    width: 50%;
  }
`;

export const CardImg = styled.img`
  width: 45px;
  height: 35px;
`;

export const CardImgWrapper = styled.div`
  width: 45px;
  height: 35px;
  svg {
    width: 45px;
    height: 35px;
  }
`;

export const CardNew = styled.div`
  margin-top: 25px;
  margin-bottom: 10px;
  height: 238px;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  border: 1px solid ${colors.GREY_LIGHT};
`;
export const SettingsWrap = styled.section`
  max-width: 832px;
  width: 100%;
  @media (max-width: 769px) {
    ${(props) =>
      props.gap === "gap2"
        ? `
    ${TitleWrap} {
      margin: 20px 0;
    }`
        : `
    ${TitleWrap} {
      margin: 18px 0;
    }`}
  }
  @media (min-width: 769px) {
    padding-top: 40px;
    ${(props) => props.gap === "gap1" && "padding-top: 20px;"}
  }
  ${TitleWrap} {
    &:first-of-type {
      margin-top: 0;
    }
  }
  .inputWrap {
    width: 100%;
    padding: 13px 0 0;
    ${RadioButtonWrap} {
      margin-top: 0;
      width: auto;
      span {
        margin-right: 0;
      }
      span + span {
        margin-left: 12px;
      }
    }
    @media (min-width: 769px) {
      padding: 9px 0;
      span + span {
        margin-left: 10px;
      }
      ${RadioButtonWrap} + ${RadioButtonWrap} {
        padding-left: 20px;
        margin-left: 12px;
      }
    }
  }
`;

export const IconWrap = styled.div`
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 15px;
  margin-left: auto;
  width: 22px;
  height: 22px;
  margin-bottom: 10px;
  @media (min-width: 769px) {
    margin-top: 12px;
  }
  .icon {
    width: 100%;
    height: 100%;
  }
`;

export const DialogWrapper = styled.div`
  margin-top: 30px;
`;

export const RestrictedContainer = styled.div`
  ${CategoryTitle} {
    margin-bottom: 0;
    padding-bottom: 0;
  }
  div + div {
    margin-bottom: 10px;
  }
  margin-top: 40px;
  max-width: 420px;
  width: 100%;
  button {
    float: right;
    width: 150px;
  }
`;

export const SecondaryTitle = styled.div`
  font-size: 14px;
  color: ${colors.GREY};
  font-family: ${fonts.latoRegular};
`;

export const QRWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 80px 0px 0px 0px;
  @media (min-width: 769px) {
    flex-direction: row;
    margin: 50px 0px 0px 0px;
  }
`;

export const QRCodeWrapper = styled.div`
  margin: 0px 0px 70px 0px;
  @media (min-width: 769px) {
    margin: 0px 30px 0px 0px;
  }
`;

export const QRTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: 769px) {
    justify-content: center;
    align-items: flex-start;
  }
`;

export const QRTitle = styled.h4`
  margin: 0px;
  font-family: ${fonts.latoBold};
  color: ${colors.GREY_DARK};
  font-size: 16px;
`;

export const QRDescription = styled.p`
  margin: 5px 0px 30px 0px;
  font-family: ${fonts.latoRegular};
  color: ${colors.GREY_SEMIDARK};
  font-size: 18px;
  line-height: 22px;
`;

export const SocialBtnWrap = styled.div`
  margin: 17px;
  ${ButtonWrap} {
    width: 100%;
  }
`;

export const StripePayoutCardErrorNotificationContainer = styled.div`
  padding: 20px;
`;
